module.exports = __webpack_public_path__ + "img/682-ea4a5c.png";